<template>
  <div class="responsive-layout" ref='scrollablePage' id='scrollablePage' :class="background">
    <div class="responsive-page" :class="background">
      <router-view />
    </div>
  </div>
</template>

<script>

import EventBus from '@/utils/event-bus';

export default {
  name: 'ResponsiveLayout',
  props: {
    background: String,
  },
  created() {
    EventBus.$on('reset-scroll', () => {
      this.resetScroll();
    });
  },
  methods: {
    resetScroll() {
      this.$refs.scrollablePage.scrollTop = 0;
    },
  },
};

function setViewportHeightAttribute() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeightAttribute();

window.addEventListener('resize', () => {
  setViewportHeightAttribute();
});
</script>

<style lang="scss" scoped>
@import "src/styles/layout";

.responsive-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
  position: fixed;

  .responsive-page {
    display: flex;
    flex-direction: column;
    width: 360px;
    height: calc(var(--vh, 1vh) * 100);
    margin-top: calc(100vh*0.05);
    @include globalPadding;
  }
}

@media (min-width: 430px) {
  .responsive-layout {

    .responsive-page {
      margin: calc(100vh*0.05) 0;

      ::-webkit-scrollbar {
        width: 0;
        background: transparent;
      }
    }
  }
}
</style>
